module.exports = __webpack_public_path__ + "static/certificate3-1a414ed681dd18a8071f45660e28595d.jpg";